import {
  SET_REPORT_TYPIFICATIONS,
  SET_REPORT_MANAGEMENT,
  SET_REPORT_TIME_PLATFORM,
  SET_COMMON_REPORTS,
  SET_REPORT_DETAIL_TIME_PLATFORM,
  SET_REPORT_CALLS_ANSWERED,
  SET_REPORT_CALLS_INCOMING,
} from "./mutations-type";
import {
  fetchReportTypifications,
  fetchReportManagementProgress,
  fetchReportTimePlatform,
  fetchCommonReport,
  fetchTotalRegisterReportTimePlatform,
  fetchReportCallsAnswered,
  fetchReportIncomingPerAgent,
  fetchReportAtcMessaging,
} from "@/app/reports/services";
import { TABLE_PAGE_SIZE_XL } from "@/app/shared/utils/constants";
const actions = {
  async fetchReportTypifications({ commit }, params) {
    const report = await fetchReportTypifications(params);
    commit(SET_REPORT_TYPIFICATIONS, report?.count);
    return report;
  },
  async fetchReportManagementProgress({ commit }, params) {
    const { query, pagination } = params;
    const report = await fetchReportManagementProgress(query, pagination);
    console.log(report);
    commit(SET_REPORT_MANAGEMENT, {
      items: report.results,
      pagination: {
        total: report.count,
        pageSize: TABLE_PAGE_SIZE_XL,
        showSizeChanger: false,
      },
    });
  },
  async fetchReportAtcMessaging({ commit }, params) {
    const { query, pagination } = params;
    const report = await fetchReportAtcMessaging(query, pagination);
    console.log(report);
    commit(SET_REPORT_MANAGEMENT, {
      items: report.results,
      pagination: {
        total: report.count,
        pageSize: TABLE_PAGE_SIZE_XL,
        showSizeChanger: false,
      },
    });
  },
  async fetchReportTimePlatform({ commit }, params) {
    const { query, pagination } = params;
    const report = await fetchReportTimePlatform(query, pagination);
    commit(SET_REPORT_TIME_PLATFORM, {
      items: report.results,
      pagination: {
        total: report.count,
        pageSize: TABLE_PAGE_SIZE_XL,
        showSizeChanger: false,
      },
    });
  },
  async fetchCommonReports({ commit }, params) {
    const { query, pagination } = params;
    const report = await fetchCommonReport(query, pagination);
    commit(SET_COMMON_REPORTS, {
      items: report.results,
      pagination: {
        total: report.count,
        pageSize: TABLE_PAGE_SIZE_XL,
        showSizeChanger: false,
      },
    });
  },
  async fetchAllDatailTimePlatform({ commit }, params) {
    const item = await fetchTotalRegisterReportTimePlatform(params);
    commit(SET_REPORT_DETAIL_TIME_PLATFORM, item);
  },
  async fetchAllCallsAnswered({ commit }, params) {
    const item = await fetchReportCallsAnswered(params);
    console.log(item, 'item fetchReportCallsAnswered');
    commit(SET_REPORT_CALLS_ANSWERED, item);
  },
  async fetchAllIncomingPerAgent({ commit }, params) {
    const item = await fetchReportIncomingPerAgent(params);
    console.log(item, 'item fetchReportIncomingPerAgent');
    let total_answered = 0, total_not_answered = 0, total_answered_whatsapp_voice = 0, total_not_answered_whatsapp_voice = 0, total = 0;
    item.forEach(el => {
      total_answered += el.answered;
      total_not_answered += el.not_answered;
      total_answered_whatsapp_voice += el.answered_whatsapp_voice;
      total_not_answered_whatsapp_voice += el.not_answered_whatsapp_voice;
      total += el.total;
    });
    const data = {
      totals: {
        answered: total_answered,
        not_answered: total_not_answered,
        answered_whatsapp_voice: total_answered_whatsapp_voice,
        not_answered_whatsapp_voice: total_not_answered_whatsapp_voice,
        total
      },
      data: item
    };
    commit(SET_REPORT_CALLS_INCOMING, data);
  },
};

export default actions;
